import { render, staticRenderFns } from "./ShowStars.vue?vue&type=template&id=5c5e1e99&scoped=true"
import script from "./ShowStars.vue?vue&type=script&lang=js"
export * from "./ShowStars.vue?vue&type=script&lang=js"
import style0 from "./ShowStars.vue?vue&type=style&index=0&id=5c5e1e99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5e1e99",
  null
  
)

export default component.exports